/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScanResultOutcomeKind } from './scan-result-outcome-kind';


export interface SearchScanResultOutcome { 
    id: number;
    kind: ScanResultOutcomeKind;
    name: string;
}



